import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { projectRole, USER_PERMISSION_MODEL, USER_ROLE_MODEL } from '@model';
import { BuyerTargetInfo, Routes } from '@components';
import actions from '@flux/action';

import {
  QUES_SECTIONS_DESCRIPTION,
  QUES_SECTIONS_SEQ,
} from '@model/questionmaires';
import TopProgressBar from './topProgressBar';
import SideProgressSection from './sideProgressSection';
// import '@style/modules/questionnaires/questionnaires.scss';
import '../../styles/modules/questionnaires/questionnaires.scss';
import { useRouteMatch } from 'react-router-dom';
import WelcomePage from './welcomePage';
import ReviewResponses from './reviewResponses';
import { ComplexityPortal } from './complexity';
import { API } from '@service';
// import ExportPdf from './pdf/exportPdf';
import { generateProjectUrlSearch } from '@utils/common';
import { getProjectInfoFromLocation } from '@utils/history';

const SectionDescription = ({ section }) => {
  const data = QUES_SECTIONS_DESCRIPTION[section];
  if (!data) {
    return null;
  }
  return (
    <div className="section-description-wrapper">
      <div className="title">{data.title}</div>
      <div className="text">{data.desc}</div>
    </div>
  );
};

const Questionnaires = (props) => {
  const {
    match: { path },
    routes,
    history,
    QSaccessData,
    questionnaireAccessHandler,
  } = props;
  const projectId = useSelector(({ common }) => common.currentId);

  const {
    isClient,
    isPwcReadOnly,
    // permission,
    // internalPermission,
    accessibleModules,
  } = useSelector(({ login, projects, common, accessibleModules }) => ({
    isClient: login.userInfo.role === USER_ROLE_MODEL.CLIENT,
    isPwcReadOnly:
      common.projectCompanyInfo?.currentUserPermission ===
      projectRole['View-Only'],
    // permission: projects.sectionsPermission.questionnairePermission,
    // internalPermission:
    //   projects.internalSectionsPermission.questionnairePermission,
    accessibleModules: projects?.originAccessibleModules,
  }));
  const [isLeftExpand, setLeftExpand] = useState(true);
  const [isRightExpand, setRightExpand] = useState(true);
  const isPdfPage = window.location.pathname.includes('export-pdf');
  const dispatch = useDispatch();
  const { params: { currentSection } = {} } =
    useRouteMatch(`${path}/:currentSection`) || {};
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  // !isClient ||
  // (isClient &&
  //   permission.includes(USER_PERMISSION_MODEL.QUESTIONNAIRE.welcome));
  const canSeeComplexity =
    !isClient ||
    accessibleModules?.moduleList?.includes(
      USER_PERMISSION_MODEL.QUESTIONNAIRE.complexity,
    );
  // (isClient &&
  //   permission.includes(USER_PERMISSION_MODEL.QUESTIONNAIRE.complexity)) ||
  // (isPwcReadOnly &&
  //   internalPermission.includes(
  //     USER_PERMISSION_MODEL.QUESTIONNAIRE.complexity,
  //   ));
  const canSeeQues = isInternal && !(isClient || isPwcReadOnly);

  useEffect(() => {
    dispatch(actions.fetchQuesCollections());
  }, []);

  useEffect(() => {
    (async () => {
      const accessRes = await API.getQuestionnaireAccess(projectId);
      questionnaireAccessHandler(accessRes);
    })();
  }, [projectId]);
  useEffect(() => {
    setRightExpand(true);
    const { projectId: currentId } = getProjectInfoFromLocation(
      history.location,
    );

    if (
      !currentId &&
      // !projectName &&
      history.location.pathname.includes('questionnaires')
    ) {
      history.replace(
        `${history.location.pathname}?${generateProjectUrlSearch(projectId)}`,
      );
    }
  }, [history.location.pathname]);

  const renderContent = () => {
    if (currentSection && currentSection === 'review-responses') {
      return (
        <ReviewResponses
          QSaccessData={QSaccessData}
          questionnaireAccessHandler={questionnaireAccessHandler}
        />
      );
    }

    if (currentSection === 'complexity') {
      return (
        <ComplexityPortal
          handleLeftExpand={setLeftExpand}
          handleRightExpand={setRightExpand}
          isRightExpand={isRightExpand}
          isLeftExpand={isLeftExpand}
        />
      );
    }
    // if (isPdfPage) {
    //   return (
    //     <ExportPdf
    //       handleToggleExpand={setRightExpand}
    //       isExpand={isRightExpand}
    //     />
    //   );
    // }

    if (currentSection && !QUES_SECTIONS_SEQ.includes(currentSection)) {
      return (
        <WelcomePage canSeeQues={canSeeQues} canSeeComplex={canSeeComplexity} />
      );
    }
    const pointerEventsHandler = () => {
      if (QSaccessData[currentSection]?.disabled) {
        return 'section-pointer-events-disabled';
      }
      return 'section-pointer-events-active';
    };
    return (
      <div className={pointerEventsHandler()}>
        <TopProgressBar />
        <div className="buyer-target-info-wrapper">
          <BuyerTargetInfo />
        </div>
        <SectionDescription section={currentSection} />
        <Routes routeData={routes} rootPath={path} />
      </div>
    );
  };
  function getProperClass() {
    if (isLeftExpand && isRightExpand) {
      return 'narrow';
    } else if (isLeftExpand && !isRightExpand) {
      return '';
    } else if (!isLeftExpand && isRightExpand) {
      return 'is-siderbar-expanded';
    }
    return '';
  }
  return (
    <div
      className="questionnaires-container"
      style={isPdfPage ? { height: '100%' } : {}}
    >
      <SideProgressSection
        currentSection={currentSection}
        isExpanded={isLeftExpand}
        canSeeComplex={canSeeComplexity}
        canSeeQues={canSeeQues}
      />

      <div className={`questionnaires-content-wrapper ${getProperClass()}`}>
        {renderContent()}
      </div>
    </div>
  );
};

const mapStateToProps = ({ question }) => ({
  QSaccessData: question.QSaccessData,
});

const mapDispatchToProps = (dispatch) => ({
  questionnaireAccessHandler(obj) {
    dispatch(actions.questionnaireAccessHandler(obj));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Questionnaires);
